import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class NavegationStateService {
    home$ = new BehaviorSubject(false);
    login$ = new BehaviorSubject(false);
    forgot$ = new BehaviorSubject(false);
    newPassword$ = new BehaviorSubject(false);

    constructor() {
        //
    }
}
